import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { FormaRecebimentoRequest } from '../../requests/financas/forma-recebimento.request';
import { FormaRecebimentoResponse } from '../../responses/financas/forma-recebimento.response';
import { FormaRecebimentoGetByIdResponse } from '../../responses/financas/forma-recebimento-get-by-id.response';
import { FormaRecebimentoLookupResponse } from '../../responses/financas/forma-recebimento-lookup.response';
import { DestinosBoletoLookupResponse } from '../../responses/financas/destinos-boleto-lookup.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class FormaRecebimentoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'FormaRecebimento';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(pagina: number = 1, tamanhoPagina: number = 20, descricao?: string): Observable<FormaRecebimentoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<FormaRecebimentoResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<FormaRecebimentoGetByIdResponse> {
        const url = `${this.apiUrl}/${id}`;
        return this.httpClient
            .get<FormaRecebimentoGetByIdResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public post(request: FormaRecebimentoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(id: number, request: FormaRecebimentoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${id}`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public bulkDelete(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { idsFormaRecebimento: ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public setFavorito(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${id}/favorito`;
        return this.httpClient
            .patch<ReturnStruct>(url, null, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookup(): Observable<FormaRecebimentoLookupResponse> {
        const url = `${this.apiUrl}/lookup`;
        return this.httpClient
            .get<FormaRecebimentoLookupResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getDestinosBoletoLookup(): Observable<DestinosBoletoLookupResponse> {
        const url = `${this.apiUrl}/lookup-boletos`;
        return this.httpClient
            .get<DestinosBoletoLookupResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

}
